module.exports = new __parcel__URL__("sig-blk-fr.6dce7e74.svg").toString();